import { useEffect } from 'react';
import type React from 'react';

import { useLocation } from 'react-router';

import { PageBody } from '../components/PageBody';
import { PageHeading } from '../components/PageHeading';
import { PageTabs } from '../components/PageTabs';

import { useTrackPageView } from './hooks/useTrackPageView';

function useScrollToHash(): void {
	const { hash } = useLocation();
	useEffect(() => {
		const id = hash.slice(1);
		if (!id) {
			window.scrollTo(0, 0);
			return undefined;
		}
		const el = document.getElementById(id);
		if (el) {
			// Content already rendered (click navigation) - scroll immediately
			el.scrollIntoView({ behavior: 'smooth', block: 'start' });
			return undefined;
		}
		// Content not yet in DOM (initial deep-link load) - wait for render
		const timeoutId = window.setTimeout(() => {
			document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
		}, 300);
		return () => window.clearTimeout(timeoutId);
	}, [hash]);
}

export const Layout: React.FC = () => {
	useTrackPageView();
	useScrollToHash();

	return (
		<div className="container pb-4">
			<PageHeading />
			<PageTabs />
			<PageBody />
		</div>
	);
};
